module.exports = __webpack_public_path__ + "img/logo_vcf.6f82d31a.jpg";